function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#3c00dc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00dce6"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 218"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-map-marker",
  d: "M37.329 108.707C5.844 63.064 0 58.379 0 41.6a41.6 41.6 0 0183.209 0c0 16.775-5.844 21.459-37.329 67.1a5.2 5.2 0 01-8.551 0z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 97",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 213",
  d: "M69.381 42.788l-4.747.32a23.845 23.845 0 00-22.2 22.2l-.32 4.757a.5.5 0 01-1 0l-.321-4.757a23.845 23.845 0 00-22.2-22.2l-4.747-.32a.471.471 0 010-.941l4.747-.32a23.845 23.845 0 0022.2-22.2l.321-4.747a.5.5 0 111 0l.32 4.747a23.845 23.845 0 0022.213 22.2l4.747.32a.471.471 0 11-.01.941z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 214",
  d: "M69.893 42.788l-4.747.32a23.845 23.845 0 00-22.2 22.2l-.32 4.757a.5.5 0 01-1 0l-.321-4.757a23.845 23.845 0 00-22.2-22.2l-4.747-.32a.471.471 0 010-.941l4.747-.32a23.845 23.845 0 0022.2-22.2l.321-4.747a.5.5 0 111 0l.32 4.747a23.845 23.845 0 0022.213 22.2l4.747.32a.471.471 0 11-.01.941z",
  opacity: 0.1
})));

function SvgMapMarkerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.209,
    height: 110.945,
    viewBox: "0 0 83.209 110.945"
  }, props), _ref, _ref2);
}

export default SvgMapMarkerinline;